import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import bqUserIcon from 'img/bq-user-icon.svg'
import WithUser from 'hocs/WithUser'
import { Menu, Dropdown, Button, Tooltip } from 'antd'
import { BulbOutlined, BulbFilled } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faBars } from '@fortawesome/free-solid-svg-icons'
import WithData from 'hocs/WithData'
import { useTheme } from '../../theme/ThemeContext'

const DashboardNavbar = props => {
  const { theme, toggleTheme } = useTheme()

  const logoutUser = () => {
    props.unsetUser()
    props.unsetData()
  }

  const menu = (
    <Menu>
      <Menu.Item>
        {/* <Link to="/users/my-account" className="">
          My Account
        </Link> */}
      </Menu.Item>
      <Menu.Item onClick={logoutUser}>Logout</Menu.Item>
    </Menu>
  )

  return (
    <div className="dashboard_navbar">
      <div className="dashboard_navbar_left" onClick={props.handleOpen}>
        <FontAwesomeIcon icon={faBars} />
      </div>

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
        <Tooltip title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
          <Button
            type="text"
            shape="circle"
            aria-label="Toggle dark mode"
            icon={theme === 'dark' ? <BulbFilled /> : <BulbOutlined />}
            onClick={toggleTheme}
            style={{ fontSize: 18, marginRight: 12 }}
          />
        </Tooltip>
      </div>

      <Dropdown overlay={menu} placement="bottom">
        <div
          className="dashboard_navbar_right"
          onClick={() => props.history.push('#')}
        >
          <span>
            <img src={bqUserIcon} alt="user-icon" />{' '}
            {`${props.authUser.user &&
              props.authUser.user.firstName.toUpperCase()}`}
          </span>
          <span
            style={{ fontSize: '1.6rem' }}
            className="dashboard_navbar_left_text ml-1rem"
          >
            <FontAwesomeIcon icon={faAngleDown} />
          </span>
        </div>
      </Dropdown>
    </div>
  )
}

DashboardNavbar.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  handleOpen: PropTypes.func,
  authUser: PropTypes.object,
  unsetUser: PropTypes.func,
  unsetData: PropTypes.func
}

export default withRouter(WithUser(WithData(DashboardNavbar)))
